import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../../services/apiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import { logException } from '../../../../../sentry';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinStateBridgeNiota',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    bridgeConfig: {
      type: Object,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      // the current result-set for the autocomplete device search
      niotaDevices: [],
      loading: false,
      loadingDevices: false,
      niotaDeviceSearch: '',
      selectedNiotaDevice: null,
      niotaDeviceVariableHeaders: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'value',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'milliseconds_ago',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }],
      niotaDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      // the retrieved variables for the selected device
      niotaDeviceVariables: null,
      selectedNiotaDeviceVariable: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.selectedNiotaDevice) && !isNullOrEmpty(this.selectedNiotaDeviceVariable) && this.selectedNiotaDeviceVariable.length > 0;
    }
  }),
  watch: {
    niotaDeviceSearch: function niotaDeviceSearch(val) {
      if (!val || val.length < 2) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `niotaDevices` to an array with only `selectedNiotaDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.niotaDevices = [this.selectedNiotaDevice].filter(function (d) {
          return d;
        });
        return;
      } else if (!this.bridgeConfig || !this.bridgeConfig.configId) {
        // if no niota account is selected do nothing
        return;
      } // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set


      if (!this.selectedNiotaDevice || !this.selectedNiotaDevice.title || val !== this.selectedNiotaDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    bridgeConfig: function bridgeConfig(val) {
      var _this = this;

      if (val) {
        this.$nextTick(function () {
          var deviveInput = _this.$refs.niotaDevice.$el.querySelector('input');

          deviveInput.focus();
        });
        this.emitSelection();
      }
    },
    selectedNiotaDevice: function selectedNiotaDevice(val) {
      if (val !== null) {
        this.fetchVariables();
      }

      this.emitSelection();
    },
    selectedNiotaDeviceVariable: function selectedNiotaDeviceVariable() {
      this.emitSelection();
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode !== 'create' && this.mode !== 'import') {
      if (get(this.bridgeConfig, 'configId') && get(this.lclModel, 'properties.binding.options.identifier')) {
        ApiService.getNiotaDevice(this.bridgeConfig.configId, this.lclModel.properties.binding.options.identifier).then(function (device) {
          if (!device || !device.id) {
            throw new Error('NIOTA_DEVICE_NOT_FOUND');
          }

          _this2.niotaDevices = device ? [device] : null;
          _this2.selectedNiotaDevice = device;
        }).catch(function (error) {
          var errorMessage = get(error, 'response.data.message', error.message);
          var errorOutput = _this2.$i18n_te("Error.".concat(errorMessage)) ? _this2.$i18n_t("Error.".concat(errorMessage)) : _this2.$i18n_t(errorMessage);

          _this2.$snack(errorOutput, 'error');

          logException(error);
          _this2.niotaDevices = null;
          _this2.selectedNiotaDevice = null;
        }).finally(function () {
          _this2.loading = false;
        });
      } else {
        this.loading = false;
      }

      this.selectedNiotaDeviceVariable = [{
        variable: this.lclModel.properties.binding.options.variable
      }];
    }
  },
  methods: {
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedNiotaDeviceVariable, '[0].value_type_name'),
        variable: get(this.selectedNiotaDeviceVariable, '[0].variable'),
        value: get(this.selectedNiotaDeviceVariable, '[0].value')
      });
    },
    fetchDevices: debounce(function () {
      var _this3 = this;

      this.loadingDevices = true;
      ApiService.fetchNiotaDevices(this.bridgeConfig.configId, this.niotaDeviceSearch).then(function (devices) {
        // only allow devices with a devicetype, as otherwise there are no parsed variables to choose from
        _this3.niotaDevices = devices.filter(function (device) {
          return device.deviceTypeId;
        });
      }).catch(function (error) {
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this3.$i18n_te("Error.".concat(errorMessage)) ? _this3.$i18n_t("Error.".concat(errorMessage)) : _this3.$i18n_t(errorMessage);

        _this3.$snack(errorOutput, 'error');

        _this3.niotaDevices = [];
        logException(error);
      }).finally(function () {
        _this3.loadingDevices = false;
      });
    }, 250),
    fetchVariables: function fetchVariables() {
      var _this4 = this;

      this.niotaDeviceVariables = null;

      if (this.selectedNiotaDevice === undefined || this.selectedNiotaDevice.id === undefined) {
        return;
      }

      ApiService.fetchNiotaDeviceVariables(this.bridgeConfig.configId, this.selectedNiotaDevice.id).then(function (variables) {
        var variableKeys = Object.keys(variables);
        _this4.niotaDeviceVariables = variableKeys.map(function (key) {
          var variable = variables[key];

          if (variable.time) {
            variable['milliseconds_ago'] = new Date() - new Date(variable.time);
            variable['time_ago'] = variable['milliseconds_ago'];
            var units = ['seconds', 'minutes', 'hours', 'days', 'months'];
            var conversion = [1000, 60, 60, 24, 30];
            var selectedUnit = 0;

            while (variable['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
              variable['time_ago'] = Math.floor(variable['time_ago'] / conversion[selectedUnit]);
              selectedUnit++;
            }

            selectedUnit--;
            variable['time_ago'] = "".concat(variable['time_ago'], " ").concat(units[selectedUnit]);
          }

          return variable;
        });
      }).catch(function (error) {
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this4.$i18n_te("Error.".concat(errorMessage)) ? _this4.$i18n_t("Error.".concat(errorMessage)) : _this4.$i18n_t(errorMessage);

        _this4.$snack(errorOutput, 'error');

        _this4.niotaDeviceVariables = [];
        console.error(error);
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = this.selectedNiotaDevice.id;
      this.lclModel.properties.binding.options.variable = this.selectedNiotaDeviceVariable[0].variable;
    }
  }
};